import store from '../store/index';
window.onbeforeunload = function() {
  console.log('beforeunload', store.state.card);

  store.state.card.pageCell;
  // store.state.card.pageCell.forEach(page => {
  //   page.layout && (page.layout.width = 706);
  //   //布局：1、一栏，2、二栏，3三栏
  // });
  // sessionStorage.setItem('pageCell', JSON.stringify(store.state.card.pageCell));
  if (window.location.href.includes('card')) {
    return 1;
  }
};
